import { useAssessmentStore } from '../../store/useAssessmentStore';
import { CohortForm } from '../cohort-form';

export const BeforeYouBegin = () => {
  const assessmentPage = useAssessmentStore((state) => state.assessmentPage);

  return (
    <div className="mt-sh-30">
      <h1 className="mb-2 font-cadiz text-sh-28-32 font-bold">{assessmentPage?.beforeYouBeginTitle}</h1>
      <p
        className="arrow-scope quote-scope font-cadiz text-base text-gray-600"
        dangerouslySetInnerHTML={{
          __html: assessmentPage?.beforeYouBeginDescription || '',
        }}
      />
      <CohortForm cohortsEmpty />
    </div>
  );
};
